import { CrudState } from "@/store/Crud/State";
export class State extends CrudState {
  pngMimeType = "";
  pngFileName = "";
  pngSuccess = null;
  pngItem: Record<string, any> = {};
  pdfMimeType = "";
}
